import { create } from 'zustand';
import { usePayeesStore as useCorePayeesStore } from '@flows.cash/core';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { Payee } from '@flows.cash/types';

export type { Payee };

export const usePayeesStore = () => {
  const { t } = useTranslation();
  const coreStore = useCorePayeesStore();

  return {
    ...coreStore,
    addPayee: async (data: Parameters<typeof coreStore.addPayee>[0]) => {
      try {
        await coreStore.addPayee(data);
        toast.success(t('payees.addSuccess'));
      } catch (error) {
        toast.error(t('payees.addError'));
        throw error;
      }
    },

    updatePayee: async (payeeId: string, data: Parameters<typeof coreStore.updatePayee>[1]) => {
      try {
        await coreStore.updatePayee(payeeId, data);
        toast.success(t('payees.updateSuccess'));
      } catch (error) {
        toast.error(t('payees.updateError'));
        throw error;
      }
    },

    deletePayee: async (userId: string, payeeId: string) => {
      try {
        await coreStore.deletePayee(userId, payeeId);
        toast.success(t('payees.deleteSuccess'));
      } catch (error) {
        toast.error(t('payees.deleteError'));
        throw error;
      }
    }
  };
};
